/**
 * DeviceRedirects entity class
 */

import { PLATFORM_TYPES } from 'app/core/constants'
import { clone } from 'app/helpers/object'

/**
 * DeviceRedirectsFactory
 * returns DeviceRedirects entity class
 *
 * @class DeviceRedirectsFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.DeviceRedirects} class
 *
 * @ngdoc factory
 * @name mwApp.factory:DeviceRedirectsFactory
 */
/* @ngInject */
export default function DeviceRedirectsFactory ($http, $q, alertLiteSvc, Type, Entity, onOffMixin, authSvc) {
  // use generic hasOwnProperty function
  var hasOwnProperty = Object.prototype.hasOwnProperty

  /* === DeviceRedirects class === */

  /**
   * DeviceRedirects model
   *
   * @class DeviceRedirects
   * @classdesc DeviceRedirects model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.onOffMixin
   * @param {Object} [object] - initial object, containing DeviceRedirects entity fields
   * @return {models.DeviceRedirects} DeviceRedirects entity
   */
  function DeviceRedirects () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  DeviceRedirects.prototype = Object.create(Entity.prototype)
  DeviceRedirects.prototype.constructor = DeviceRedirects

  /* === DeviceRedirects instance methods & fields === */

  Object.assign(DeviceRedirects.prototype, {

    /**
     * instance fields
     *
     * @memberof models.DeviceRedirects#
     * @type {Object}
     */
    _fields: {
      id: Number,
      name: String,
      enabled: Boolean,
      url: String
    },

    /**
     * instance fields by types
     *
     * @memberof models.DeviceRedirects#
     * @type {Object}
     */
    _fieldsByTypes: {
      common: [
        'id',
        'enabled',
        'name',
        'status',
        'token',
        'url'
      ]
    },

    /**
     * url template
     *
     * @memberof models.DeviceRedirects#
     * @type {String}
     */
    _urlTemplate: 'api/deviceredirects/{{::id}}',

    /**
     * public url template
     *
     * @memberof models.DeviceRedirects#
     * @type {String}
     */
    _publicUrlTemplate: 'deviceredirects/{{::id}}',

    /**
     * Get underlying object
     *
     * @memberof models.DeviceRedirects#
     * @return {Object} new underlying object as plain object
     * @override
     */
    _object: function () {
      var ret = Entity.prototype._object.apply(this, arguments)

      // leave only necessary fields for that type of extension node
      var fields = this._fieldsByTypes.common
      for (var f in ret) {
        if (hasOwnProperty.call(ret, f) && fields.indexOf(f) === -1) {
          delete ret[f]
        }
      }

      return ret
    },

    /**
     * Get platforms array with checked flags, depending on network platforms array
     *
     * @param {String[]} def - default flags
     * @return {Object[]}
     * @memberof models.DeviceRedirects#
     */
    _enhancePlatforms: function (def) {
      var ret = clone(PLATFORM_TYPES.filter((p) => {
        return !(!authSvc.hasEnabledFlag('WEB_PLATFORM_ENABLED') && p.name === 'WEB');
      }))
      if (this._isNew() && def) {
        for (let i = ret.length; i--;) {
          if (def.indexOf(ret[i].name) !== -1) {
            ret[i].checked = true
          }
        }
      } else
      if (this.platforms && this.platforms.length) {
        for (let i = ret.length; i--;) {
          ret[i].checked = this.platforms.indexOf(ret[i].name) !== -1
        }
      }
      return ret
    },

    /**
     * Set network platforms array from platforms array with checked flags
     *
     * @param {Object[]} platforms - platforms array
     * @memberof models.DeviceRedirects#
     */
    _reducePlatforms: function (platforms) {
      this.platforms = []
      for (var i = platforms.length; i--;) {
        if (platforms[i].checked) {
          this.platforms.push(platforms[i].name)
        }
      }
      return this
    }

  }, onOffMixin)

  /* === DeviceRedirects static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(DeviceRedirects, Entity)
  DeviceRedirects._name = 'DeviceRedirects'
  DeviceRedirects.init()

  // permissions
  DeviceRedirects.access = {
    view: 'viewExtension',
    create: 'createExtension',
    edit: 'editExtension',
    delete: 'deleteExtension'
  }

  return DeviceRedirects
}
